export const AUTH = 'AUTH';
export const LOGIN_ACTION = `${AUTH}/LOGIN`;
export const FORGOT_PASSWORD_ACTION = `${AUTH}/FORGOT_PASSWORD`;
export const RESET_PASSWORD_ACTION = `${AUTH}/RESET_PASSWORD`;
export const LOGOUT_ACTION = `${AUTH}/LOGOUT`;
export const ME_ACTION = `${AUTH}/ME`;
export const UPDATE_USER = `${AUTH}/UPDATE_USER`;
export const VERIFY_EMAIL = `${AUTH}/VERIFY_EMAIL`;
export const RESEND_VERIFICATION = `${AUTH}/RESEND_VERIFICATION`;
